import { render, staticRenderFns } from "./UserRemove.vue?vue&type=template&id=6215d4ce&"
import script from "./UserRemove.vue?vue&type=script&lang=js&"
export * from "./UserRemove.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports